import {
    Exercise,
    LabelBody,
    LabelDisplay2,
    SecondaryButton,
    Spacer,
} from '../../components';
import { ExerciseData, ExerciseViewProps } from '../../exercises';
import { ExerciseStatus } from '../../interfaces';

export const exerciseData31Completed: ExerciseData = {
    ExerciseView: Module3Exercise1Completed,
    dataKeys: [],
    questions: [],
};

function Module3Exercise1Completed({ onContinue }: ExerciseViewProps) {
    return (
        <Exercise title="" className="clouds">
            <Spacer />
            <LabelDisplay2 className="mb-10 text-center">
                Du er godt på vej!
            </LabelDisplay2>
            <LabelBody className="text-center">
                Du er i gang med at lære mere om energi, og hvad du kan gøre for
                at skabe mere bæredygtig energi i din hverdag. Husk at det er
                dig, der bestemmer, hvor det giver mening for dig at starte. Du
                kan prøve et enkelt tip af eller sætte gang i at arbejde med
                flere energidimensioner på en gang. Det er op til dig.
            </LabelBody>
            <LabelBody className="mt-30 text-center">
                Vi anbefaler, at du holder en pause nu og vender tilbage senere.
            </LabelBody>
            <Spacer />
            <SecondaryButton
                className="mt-30"
                onClick={() =>
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: false,
                    })
                }
            >
                Afslut
            </SecondaryButton>
        </Exercise>
    );
}
